/**
 * Hộp xác nhận khi đổi NGÀNH ở Cấu hình → Thông tin tiệm (v0.23.0, chủ dự án chốt Q3 28/10/2026): ngoài câu chung "màu và
 * biểu tượng đổi", hộp còn nói hai điều đổi ÂM THẦM theo ngành — chỉ khi thật sự khác:
 *   - tên gọi người làm dịch vụ ("Kỹ thuật viên" ↔ "Nhân viên") khi hai ngành khác NHÓM (text/theo-nganh.ts);
 *   - ngày "nhắc khách quay lại" mặc định của dịch vụ chưa tự đặt (tính lúc đọc từ `NGANH[n].quayLaiNgay`).
 * Hàm thuần để test đơn vị; chọn câu nằm ở đây, chữ nằm ở `text/thong-tin-tiem.ts`.
 */
import { NGANH, type NganhTiem } from '@sapa/shared'
import { chuTheoNhom } from './text/theo-nganh.ts'

export interface CauHoiDoiNganh {
  /** Tên gọi người làm dịch vụ cũ → mới — chỉ khi khác nhóm ngành. */
  tenGoi?: { readonly cu: string; readonly moi: string }
  /** `[ngày mới, ngày cũ]` — chỉ khi chu kỳ nhắc quay lại mặc định khác nhau. */
  quayLai?: readonly [number, number]
}

export function cauHoiDoiNganh(cu: NganhTiem, moi: NganhTiem): CauHoiDoiNganh {
  const ra: CauHoiDoiNganh = {}
  if (NGANH[cu].nhom !== NGANH[moi].nhom)
    ra.tenGoi = {
      cu: chuTheoNhom(NGANH[cu].nhom).nhanVien,
      moi: chuTheoNhom(NGANH[moi].nhom).nhanVien,
    }
  if (NGANH[cu].quayLaiNgay !== NGANH[moi].quayLaiNgay)
    ra.quayLai = [NGANH[moi].quayLaiNgay, NGANH[cu].quayLaiNgay]
  return ra
}
